/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon16Regular = forwardRef('MediaUiAPlayForwardIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.75 3a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0V3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.365 2.528A1.35 1.35 0 0 0 6.25 3.641v8.718a1.35 1.35 0 0 0 2.115 1.113l6.34-4.36a1.35 1.35 0 0 0 0-2.224l-6.34-4.36ZM13.676 8 7.75 12.074V3.926L13.676 8Z" })));
});
